import { Typography } from "@material-ui/core"
import { AiBlessing } from "api"
import { usePurchaseContext } from "components/PurchasePage/PurchaseContext"
import Image from "next/image"
import { useEffect } from "react"
import { isDesktop } from "react-device-detect"
import styled from "styled-components"
import { Navigation, Pagination } from "swiper"
import "swiper/css"
import "swiper/css/bundle"
import "swiper/css/pagination"
import { Swiper, SwiperSlide } from "swiper/react"
import colors from "theme/colors"
import { useCreateAiContext } from "./CreateAiContext"
export type CategoryResponse = {
  name: string
  imageUrl: string
  id: number
}

type CategoriesProps = {
  categories: AiBlessing[]
}

const StyledCategories = styled.div`
  margin-bottom: 40px;
`
const StyledTitle = styled(Typography).attrs({
  component: "h2",
  variant: "h2",
})`
  color: ${colors.black};
  white-space: nowrap;
  font-size: 26px;
  line-height: 0.6;
  font-family: Speedee, NarkisBlock, sans-serif;
  margin-bottom: 16px;
  text-align: right;
`
const StyledSwiper = styled(Swiper)`
  width: 100%;
  height: 100%;
  margin-bottom: 60px;
  margin-top: 13px;
  &:last-child {
    margin-bottom: 60px;
  }
  ${(p) => p.theme.breakpoints.down("sm")} {
    margin-bottom: 40px;
    .swiper-slide {
      -webkit-backface-visibility: hidden;
      -webkit-transform: translate3d(0, 0, 0);
    }
  }
  ${(p) => p.theme.breakpoints.up("md")} {
    .swiper-slide {
      text-align: center;
      font-size: 18px;
      background: ${colors.white};
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      align-items: start;

      // BEN UPDATE
      width: auto;
    }
  }
`

const StyledCategory = styled.button<{ $isSelected: boolean }>`
  height: 104px;
  width: 116px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4px;
  border: solid 1px
    ${(p) => (p.$isSelected ? colors.darkGreen : colors.disabled)};
  border-radius: 8px;
  background-color: white;
  gap: 4px;
  ${(p) => p.theme.breakpoints.up("md")} {
    height: 178px;
    width: 160px;
    cursor: pointer;
  }
`
const swiperBreakpoints = {
  640: {
    slidesPerView: "auto",
    slidesPerGroup: 1,
    slidesOffsetBefore: 0,
  },
}
const StyledExplanation = styled(Typography).attrs({
  variant: "body1",
})<{ $isSelected: boolean }>`
  font-size: 24px;
  font-weight: 100;
  color: ${(p) => (p.$isSelected ? colors.black : colors.warmGray)};

  line-height: 0.92;
  text-align: right;

  ${(p) => p.theme.breakpoints.down("sm")} {
    font-size: 18px;
  }
`
const CategoriesAi = ({ categories }: CategoriesProps) => {
  const { categoryName } = usePurchaseContext()
  const { blessingId, setBlessingId, setPropertiesData } = useCreateAiContext()

  useEffect(() => {
    if (!blessingId && categories) {
      setBlessingId(categories[0]?.blessingId)
    }
  }, [])

  return (
    <StyledCategories>
      <StyledTitle>קטגוריות</StyledTitle>
      <StyledSwiper
        slidesPerView={2.75}
        spaceBetween={isDesktop ? 30 : -15}
        slidesPerGroup={2}
        loop={false}
        loopFillGroupWithBlank={true}
        modules={[Pagination, Navigation]}
        // @ts-ignore
        breakpoints={swiperBreakpoints}
        slidesOffsetBefore={isDesktop && 2}
      >
        {categories?.map((data) => (
          <SwiperSlide key={data.blessingId}>
            <StyledCategory
              $isSelected={blessingId === data.blessingId}
              key={data.blessingId}
              onClick={() => {
                if (blessingId !== data.blessingId) {
                  setPropertiesData([])
                }
                setBlessingId(data.blessingId)
              }}
            >
              <Image
                src={data.image.imageUrl}
                alt={data.image.alt}
                width={isDesktop ? 144 : 96}
                height={isDesktop ? 128 : 80}
              />
              <StyledExplanation $isSelected={categoryName === data.name}>
                {data.categoryName}
              </StyledExplanation>
            </StyledCategory>
          </SwiperSlide>
        ))}
      </StyledSwiper>
    </StyledCategories>
  )
}

export default CategoriesAi
